module.exports = __webpack_public_path__ + "static/1297589734.910c0fbe.jpg";